/*
 *
 * MeasurementDetails reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_DIVISIONS_MEASURE_WATCHER,
  GET_DIVISIONS_MEASURE_SUCCESS,
  GET_DIVISIONS_MEASURE_FAILED,
  GET_QUALITATIVE_QUES_WATCHER,
  GET_QUALITATIVE_QUES_SUCCESS,
  GET_QUALITATIVE_QUES_FAILED,
  GET_DATE_PROG_WATCHER,
  GET_DATE_PROG_SUCCESS,
  GET_DATE_PROG_FAILED,
  COUNT_COLLABORATORS_SUCCESS,
  GET_RECIPIENTS_WATCHER,
  GET_RECIPIENTS_SUCCESS,
  GET_RECIPIENTS_FAILED,
  GET_DATES_WATCHER,
  GET_DATES_SUCCESS,
  GET_DATES_FAILED,
  GET_SURVEYS_TYPE_WATCHER,
  GET_SURVEYS_TYPE_SUCCESS,
  GET_SURVEYS_TYPE_FAILED,
  GET_LEADERS_DETAILS_WATCHER,
  GET_LEADERS_DETAILS_SUCCESS,
  GET_LEADERS_DETAILS_FAILED,
  GET_DIVISIONS_TREE_MEASURE_WATCHER,
  GET_DIVISIONS_TREE_MEASURE_SUCCESS,
  GET_DIVISIONS_TREE_MEASURE_FAILED,
  SET_INCLUDE_SUBDIVISION_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_RECIPIENTS_SEGMENTS_WATCHER,
  GET_RECIPIENTS_SEGMENTS_SUCCESS,
  GET_RECIPIENTS_SEGMENTS_FAILED,
  GET_LEADERS_SEGMENTS_WATCHER,
  GET_LEADERS_SEGMENTS_SUCCESS,
  GET_LEADERS_SEGMENTS_FAILED,
  GET_POSSIBLE_RECIPIENTS_WATCHER,
  GET_POSSIBLE_RECIPIENTS_SUCCESS,
  GET_POSSIBLE_RECIPIENTS_FAILED,
  ADD_COLLABORATORS_WATCHER,
  ADD_COLLABORATORS_SUCCESS,
  ADD_COLLABORATORS_FAILED,
  GET_MEASURE_ENGAGEMENT_WATCHER,
  GET_MEASURE_ENGAGEMENT_SUCCESS,
  GET_MEASURE_ENGAGEMENT_FAILED,
  GET_MEASURE_GENERAL_WATCHER,
  GET_MEASURE_GENERAL_SUCCESS,
  GET_MEASURE_GENERAL_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_INFO_SUCCESS,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_FAILED,
  GET_DIMENSIONS_RANK_WATCHER,
  GET_DIMENSIONS_RANK_FAILED,
  GET_DIMENSIONS_RANK_SUCCESS,
  GET_DETAIL_COUNTS_WATCHER,
  GET_DETAIL_COUNTS_SUCCESS,
  GET_DETAIL_COUNTS_FAILED,
  GET_MEASURE_RATE_WATCHER,
  GET_MEASURE_RATE_SUCCESS,
  GET_MEASURE_RATE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  dimensions: [],
  metric_total: {},
  isLoadingStatus: true,
  measureStatus: {},
  divisionsMeasure: [],
  divisionsMeasureMeta: { current_page: 1, last_page: 1, per_page: 15, total: 0 },
  isLoadingDivisionsMeasure: true,
  qualitativeQuestions: [],
  isLoadingQualitativeQuestions: true,
  isLoadingDates: true,
  progDates: {},
  countCollaborators: 0,
  addRecipients: [],
  isLoadingAddRecipients: true,
  datesProgramming: {},
  isLoadingDatesProgramming: true,
  surveysType: [],
  isLoadingSurveysType: true,
  leadersDetails: [],
  leadersDetailsMeta: { current_page: 1, last_page: 1, per_page: 15, total: 0 },
  isLoadingLeadersDetails: true,

  divisionsMeasureTree: [],
  isLoadingDivisionsTreeMeasure: true,
  show_include_subdivisions: true,
  measureColorRange: null,

  recipientsSegments: [],
  isLoadingRecipientsSegments: true,
  isLoadingAddCollaborators: false,
  leadersSegments: [],
  isLoadingLeadersSegments: true,

  dimensionsRank: {},
  isLoadingDimensionsRank: false,

  measureInfo: {},

  detailCounts: {},
  isLoadingDetailCounts: false,

  measureRate: {},
  isLoadingMeasureRate: false
})

function measurementDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_STATUS_WATCHER:
      return state.set("isLoadingStatus", true)
    case GET_STATUS_SUCCESS:
      return state
        .set("isLoadingStatus", false)
        .set("measureStatus", action.payload)
    case GET_STATUS_FAILED:
      return state.set("isLoadingStatus", false).set("measureStatus", {})

    case GET_LEADERS_DETAILS_WATCHER:
      return state
        .set("isLoadingLeadersDetails", true)
    case GET_LEADERS_DETAILS_SUCCESS:
      return state
        .set("isLoadingLeadersDetails", false)
        .set("leadersDetails", action.payload.data || action.payload)
        .set("leadersDetailsMeta", action.payload.meta || { current_page: 1, last_page: 1, per_page: 15, total: 0 })
    case GET_LEADERS_DETAILS_FAILED:
      return state
        .set("isLoadingLeadersDetails", false)
        .set("leadersDetails", [])

    case GET_SURVEYS_TYPE_WATCHER:
      return state.set("isLoadingSurveysType", true).set("surveysType", [])
    case GET_SURVEYS_TYPE_SUCCESS:
      return state
        .set("isLoadingSurveysType", false)
        .set("surveysType", action.payload)
    case GET_SURVEYS_TYPE_FAILED:
      return state.set("isLoadingSurveysType", false).set("surveysType", [])

    case GET_DATES_WATCHER:
      return state
        .set("isLoadingDatesProgramming", true)
        .set("datesProgramming", {})
    case GET_DATES_SUCCESS:
      return state
        .set("isLoadingDatesProgramming", false)
        .set("datesProgramming", action.payload)
    case GET_DATES_FAILED:
      return state
        .set("isLoadingDatesProgramming", false)
        .set("datesProgramming", {})

    case GET_RECIPIENTS_WATCHER:
      return state.set("isLoadingAddRecipients", true).set("addRecipients", [])
    case GET_RECIPIENTS_SUCCESS:
      return state
        .set("isLoadingAddRecipients", false)
        .set("addRecipients", action.payload)
    case GET_RECIPIENTS_FAILED:
      return state.set("isLoadingAddRecipients", false).set("addRecipients", [])

    case GET_RECIPIENTS_SEGMENTS_WATCHER:
      return state
        .set("isLoadingRecipientsSegments", true)
        .set("recipientsSegments", [])
    case GET_RECIPIENTS_SEGMENTS_SUCCESS:
      return state
        .set("isLoadingRecipientsSegments", false)
        .set("recipientsSegments", action.payload)
    case GET_RECIPIENTS_SEGMENTS_FAILED:
      return state
        .set("isLoadingRecipientsSegments", false)
        .set("recipientsSegments", [])

    case GET_LEADERS_SEGMENTS_WATCHER:
      return state
        .set("isLoadingLeadersSegments", true)
        .set("leadersSegments", [])
    case GET_LEADERS_SEGMENTS_SUCCESS:
      return state
        .set("isLoadingLeadersSegments", false)
        .set("leadersSegments", action.payload)
    case GET_LEADERS_SEGMENTS_FAILED:
      return state
        .set("isLoadingLeadersSegments", false)
        .set("leadersSegments", [])
    case COUNT_COLLABORATORS_SUCCESS:
      return state.set("countCollaborators", action.payload)
    case GET_DATE_PROG_WATCHER:
      return state.set("isLoadingDates", true).set("progDates", {})
    case GET_DATE_PROG_SUCCESS:
      return state.set("isLoadingDates", false).set("progDates", action.payload)
    case GET_DATE_PROG_FAILED:
      return state.set("isLoadingDates", false).set("progDates", {})

    case GET_QUALITATIVE_QUES_WATCHER:
      return state.set("isLoadingQualitativeQuestions", true)
    case GET_QUALITATIVE_QUES_SUCCESS:
      return state
        .set("isLoadingQualitativeQuestions", false)
        .set("qualitativeQuestions", action.payload)
    case GET_QUALITATIVE_QUES_FAILED:
      return state
        .set("isLoadingQualitativeQuestions", false)
        .set("qualitativeQuestions", [])

    case GET_DIVISIONS_MEASURE_WATCHER:
      return state.set("isLoadingDivisionsMeasure", true)
    case GET_DIVISIONS_MEASURE_SUCCESS:
      return state
        .set("isLoadingDivisionsMeasure", false)
        .set("divisionsMeasure", action.payload.data)
        .set("divisionsMeasureMeta", action.payload.meta)
    case GET_DIVISIONS_MEASURE_FAILED:
      return state
        .set("isLoadingDivisionsMeasure", false)
        .set("divisionsMeasure", [])
        .set("divisionsMeasureMeta", { current_page: 1, last_page: 1, per_page: 15, total: 0 })

    case GET_DIVISIONS_TREE_MEASURE_WATCHER:
      return state.set("isLoadingDivisionsTreeMeasure", true)
    case GET_DIVISIONS_TREE_MEASURE_SUCCESS:
      return state
        .set("isLoadingDivisionsTreeMeasure", false)
        .set("divisionsTreeMeasure", action.payload)
    case GET_DIVISIONS_TREE_MEASURE_FAILED:
      return state
        .set("isLoadingDivisionsTreeMeasure", false)
        .set("divisionsTreeMeasure", [])

    case GET_DIMENSIONS_WATCHER:
      return state.set("isLoading", true).set("dimensions", [])
    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensions", action.payload.dimensions)
        .set("metric_total", action.payload.metric_total)

    case GET_DIMENSIONS_FAILED:
      return state
        .set("isLoading", false)
        .set("dimensions", [])
        .set("metric_total", {})

    case SET_INCLUDE_SUBDIVISION_WATCHER:
      return state.set("show_include_subdivisions", action.payload)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)

    case GET_POSSIBLE_RECIPIENTS_WATCHER:
      return state.set("isLoadingPossibleRecipients", true)
    case GET_POSSIBLE_RECIPIENTS_SUCCESS:
      return state
        .set("isLoadingPossibleRecipients", false)
        .set("listPossibleRecipients", action.payload)
    case GET_POSSIBLE_RECIPIENTS_FAILED:
      return state
        .set("isLoadingPossibleRecipients", false)
        .set("listPossibleRecipients", [])

    case ADD_COLLABORATORS_WATCHER:
      return state.set("isLoadingAddCollaborators", true)
    case ADD_COLLABORATORS_SUCCESS:
      return state.set("isLoadingAddCollaborators", false)
    case ADD_COLLABORATORS_FAILED:
      return state.set("isLoadingAddCollaborators", false)

    case GET_MEASURE_ENGAGEMENT_WATCHER:
      return state.set("measureEngagement", {})
    case GET_MEASURE_ENGAGEMENT_SUCCESS:
      return state.set("measureEngagement", action.payload)
    case GET_MEASURE_ENGAGEMENT_FAILED:
      return state.set("measureEngagement", {})

    case GET_MEASURE_GENERAL_WATCHER:
      return state.set("measureGeneral", {})
    case GET_MEASURE_GENERAL_SUCCESS:
      return state.set("measureGeneral", action.payload)
    case GET_MEASURE_GENERAL_FAILED:
      return state.set("measureGeneral", {})

    case GET_MEASURE_TOTAL_WATCHER:
      return state.set("measureTotal", {})
    case GET_MEASURE_TOTAL_SUCCESS:
      return state.set("measureTotal", action.payload)
    case GET_MEASURE_TOTAL_FAILED:
      return state.set("measureTotal", {})

    case GET_MEASURE_INFO_WATCHER:
      return state.set("measureInfo", {})
    case GET_MEASURE_INFO_SUCCESS:
      return state.set("measureInfo", action.payload)
    case GET_MEASURE_INFO_FAILED:
      return state.set("measureInfo", {})
    default:
      return state

    case GET_DIMENSIONS_RANK_WATCHER:
      return state
        .set("isLoadingDimensionsRank", true)
        .set("dimensionsRank", {})
    case GET_DIMENSIONS_RANK_SUCCESS:
      return state
        .set("isLoadingDimensionsRank", false)
        .set("dimensionsRank", action.payload)
    case GET_DIMENSIONS_RANK_FAILED:
      return state
        .set("isLoadingDimensionsRank", false)
        .set("dimensionsRank", {})
    case GET_DETAIL_COUNTS_WATCHER:
      return state
        .set("isLoadingDetailCounts", true)
        .set("detailCounts", {})
    case GET_DETAIL_COUNTS_SUCCESS:
          return state
            .set("isLoadingDetailCounts", false)
            .set("detailCounts", action.payload)
    case GET_DETAIL_COUNTS_FAILED:
      return state
        .set("isLoadingDetailCounts", false)
    case GET_MEASURE_RATE_WATCHER:
      return state
        .set("isLoadingMeasureRate", true)
        .set("measureRate", {})
    case GET_MEASURE_RATE_SUCCESS:
          return state
            .set("isLoadingMeasureRate", false)
            .set("measureRate", action.payload)
    case GET_MEASURE_RATE_FAILED:
      return state
        .set("isLoadingMeasureRate", false)
  }
}

export default measurementDetailsReducer
